import { render, staticRenderFns } from "./pointOfsaleProfile.vue?vue&type=template&id=055cfa53&scoped=true&"
import script from "./pointOfsaleProfile.vue?vue&type=script&lang=js&"
export * from "./pointOfsaleProfile.vue?vue&type=script&lang=js&"
import style0 from "./pointOfsaleProfile.vue?vue&type=style&index=0&id=055cfa53&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055cfa53",
  null
  
)

export default component.exports